import React from 'react'
import { Link } from 'react-router-dom'
import './Join.css'

export default function JoinSignLink() {
  return (
    <div className='joinSignLink'>
      <Link to='/login'>Sign In</Link>
    </div>
  )
}
